import type { ContractStatus, ContractSignerRow, TenantStatus } from "../lib/types";

export function StatusBadge({ status }: { status: TenantStatus }) {
  return <span className={`badge status-${status}`}>{status}</span>;
}

export function ContractBadge({ status }: { status: ContractStatus }) {
  return <span className={`badge contract-${status}`}>{status}</span>;
}

export function SignerBadge({ status }: { status: ContractSignerRow["status"] }) {
  return <span className={`badge signer-${status}`}>{status}</span>;
}
